import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { t } from 'ember-intl';

import styles from './table-cell-base.module.css';

interface HotelChannelPricingTablesCellsTableCellBaseSignature {
  Args: {
    icon?: IconName;
    iconClass?: string;
    iconColor?:
      | 'default'
      | 'on-critical'
      | 'on-success'
      | 'info'
      | 'inherit'
      | 'on-intelligence';
    isLoading?: boolean;
    isPriceCell?: boolean;
    main?: string;
    mainValueClass?: string;
    mainValueHeavyText?: boolean;
    secondary?: string;
    secondaryIcon?: IconName;
    secondaryIconColor?: 'info' | 'inherit';
    showException?: boolean;
  };
}

const TableCellBase = <template>
  <div
    class="flex h-full w-full flex-col items-end justify-center"
    data-test-id="table-cell-base"
  >
    {{#if @isLoading}}
      <div class="flex w-full flex-row justify-center">
        <div
          class="loading-pulse w-[70%]"
          data-test-id="table-cell-base-loading-pulse"
        />
      </div>
    {{else}}
      <span
        class="{{styles.channel-pricing-table-cell-pr}}
          inline-flex gap-100 tabular-nums
          {{if @icon styles.channel-pricing-table-cell-pr--with-icon}}"
        data-test-id="main-value-row"
      >
        {{#if @main}}
          <span
            class="{{if @mainValueClass @mainValueClass}}
              {{if @mainValueHeavyText 'text-300--medium' 'text-200--regular'}}"
          >{{@main}}</span>
        {{/if}}
        {{#if @icon}}
          <PrismIcon
            @color={{@iconColor}}
            @name={{@icon}}
            @size="small"
            class="self-center {{@iconClass}}"
            data-test-id="table-cell-base-icon-{{@icon}}"
          />
          {{#if @showException}}
            <PrismTooltip
              @text={{t "channel_pricing.cell_exception.tooltip_text"}}
              @title={{if
                @isPriceCell
                (t "channel_pricing.cell_exception.tooltip_title.price")
                (t "channel_pricing.cell_exception.tooltip_title.restriction")
              }}
            />
          {{/if}}
        {{/if}}
      </span>

      {{#if @secondary}}
        <span
          class="{{styles.channel-pricing-table-cell-pr}}
            inline-flex gap-100 tabular-nums
            {{if
              @secondaryIcon
              styles.channel-pricing-table-cell-pr--with-icon
            }}"
          data-test-id="secondary-value-row"
        >
          <span class="text-200--regular">{{@secondary}}</span>
          {{#if @secondaryIcon}}
            <PrismIcon
              @color={{@secondaryIconColor}}
              @name={{@secondaryIcon}}
              @size="small"
              class="self-center"
              data-test-id="table-cell-secondary-icon-{{@secondaryIcon}}"
            />
          {{/if}}
        </span>
      {{/if}}

    {{/if}}
  </div>
</template> satisfies TOC<HotelChannelPricingTablesCellsTableCellBaseSignature>;

export default TableCellBase;
